import React, { Component } from 'react';
import {
    Alert,
    Badge,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Table
} from 'reactstrap';

import BreadCrumb from '../../Components/Common/BreadCrumb';
import { CertificateAPI } from "api";
import { Loading } from "custom";

const moment = require("moment");

class MyCertificates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            list: []
        };
        document.title = "I miei attestati | CLTV Cloud";
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loading: true, error: false });
        CertificateAPI.listOwn().then((list) => {
            this.setState({ list, loading: false });
        }).catch((e) => {
            console.error(e);
            this.setState({ loading: false, error: true });
        });
    };

    handleDownload = (cert) => {
        CertificateAPI.download(cert.id).catch((e) => {
            console.error(e);
            global.SweetAlert.fire({
                icon: 'error',
                title: 'Download fallito',
                text: 'Non è stato possibile scaricare l\'attestato.',
                customClass: { confirmButton: 'btn btn-danger' }
            });
        });
    };

    render() {
        const { loading, error, list } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="I miei attestati" pageTitle="Account" />

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardHeader>
                                        <h5 className="card-title mb-0">Attestati</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {loading ? (
                                            <Loading />
                                        ) : error ? (
                                            <Alert color="danger">Errore nel caricamento degli attestati. Riprova più tardi.</Alert>
                                        ) : list.length === 0 ? (
                                            <Alert color="info" className="mb-0">
                                                Non hai ancora attestati disponibili. Verranno emessi al completamento dei tuoi corsi.
                                            </Alert>
                                        ) : (
                                            <div className="table-responsive">
                                                <Table hover className="align-middle mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Livello</th>
                                                            <th>Data rilascio</th>
                                                            <th className="text-end">Azione</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list.map((c) => (
                                                            <tr key={c.id}>
                                                                <td>
                                                                    <Badge color="primary" className="fs-12">
                                                                        {c.level?.macro || c.level?.name}
                                                                    </Badge>
                                                                    {c.level?.name && c.level.macro !== c.level.name ? (
                                                                        <span className="text-muted small ms-2">({c.level.name})</span>
                                                                    ) : null}
                                                                </td>
                                                                <td>{moment(c.createdAt).format("DD/MM/YYYY")}</td>
                                                                <td className="text-end">
                                                                    <Button
                                                                        color="info"
                                                                        size="sm"
                                                                        onClick={() => this.handleDownload(c)}
                                                                    >
                                                                        <i className="ri-download-line me-1" />Scarica PDF
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default MyCertificates;
